<!-- @format -->
<script lang="ts">
  import { getStoresContext } from "~/stores";
  import type { StoresKey } from "~/stores";
  import { filter_by_search } from "./store";
  export let request_store_key: StoresKey;
  const { T } = getStoresContext(request_store_key);
  export let theme = "";

  function search(e: Event) {
    $filter_by_search = e.target?.value;
  }
</script>

<div class="col-12 col-lg-4 mb-3">
  <div class="input-group toggle-btn-group">
    <input
      type="text"
      class="form-control"
      aria-label="haku-sana"
      bind:value={$filter_by_search}
      on:change={search}
      on:input={search}
      placeholder={$T`search-menu`} />

    <div class="input-group-append" class:d-none={theme == "christmas_2023"}>
      <button class="purple-button"><i class="fas fa-search" /></button>
    </div>
  </div>
</div>

<style>
  input {
    border-radius: 0;
    border: 1px solid var(--brandColor2);
  }

  button {
    display: flex;
    align-items: center;
    height: 100%;
  }
</style>
